import React, { useCallback, useState, useEffect, useRef } from 'react'
import Breadcrumbs from './../../../components/Common/Breadcrumb'
import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle
} from "reactstrap"
import { Button, Modal, Table } from "react-bootstrap"
import ApiService from '../../../Services/ApiService';
import AlertService from './../../../Services/alertService'
import { ADMIN_USER_TYPE_ID, ERROR_KEY, SUCCESS_KEY, WARNING_KEY } from './../../../Constants/MainKeys'
import uuid from 'react-uuid'
import { addButtonSpinner, addRightSectionSpinner, removeButtonSpinner, removeRightSectionSpinner } from './../../../store/spinner/actions'
import { useDispatch, useSelector } from 'react-redux'
import HtmlHead from './../../../components/HtmlHead/HtmlHead'
import RightSectionSpinner from './../../../components/Spinners/RightSectionSpinner'
import NoData from '../../../components/NoData/NoData'
import OverlayTriggerComponent from '../../../components/OverlayTriggerComponent/OverlayTriggerComponent';
import { Link } from 'react-router-dom';
import { useWindowSize } from '../../../components/Hooks/useWindowSize';

const OrganizationWallets = (props) => {

  const title = "Organization Wallets";
  const description = "";
  const { organizationId } = props.match.params;
  const dispatch = useDispatch();
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const { language } = useSelector(state => state.Languages);
  const [wallets, setWallets] = useState([]);
  const [walletData, setWalletData] = useState(null);
  const { user } = useSelector(state => state.Login);
  const isAdmin = user.userTypeId === ADMIN_USER_TYPE_ID;
  const windowSize = useWindowSize();

  useEffect(() => {
    getOrganizationWallets();
  }, [])

  const getOrganizationWallets = () => {
    if (!organizationId && !user?.organizationId) {
      return false;
    }
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getOrganizationWallets(isAdmin ? organizationId : user?.organizationId).then(response => {
      if (response && response.data) {
        setWallets(response.data);
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }

  const getWalletBalance = (walletId) => {
    if (!walletId) {
      return false;
    }
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getWalletBalance(walletId).then(response => {
      if (response && response.data) {
        setWalletData(response.data);
      } else {
        AlertService.alert(WARNING_KEY, "Unable to retrieve wallet balance. Please try again later.");
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }

  const onClose = () => {
    setWalletData(false);
  }

  const copyLink = (link) => {
    if (!link) { return false; }
    navigator.clipboard.writeText(link);
    AlertService.alert(SUCCESS_KEY, "Copied");
  }

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />

        <div className="container-fluid">
          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Merchant Wallets"
            isShowGoBackButton={isAdmin ? true : false}
            goBack={() => window.history.back()}
          />
          <Row>
            <Col lg={12}>
              <Row className='mb-4'>

                <Col sm={12}>
                  <Card id='table' className="position-relative">

                    <CardBody className="pb-0">


                      <CardTitle className="mb-4">
                        <div className='d-flex justify-content-between align-items-center'>
                          Wallets
                        </div>
                        <hr />
                      </CardTitle>
                      {
                        wallets && wallets.length ? (
                          <Table striped bordered hover responsive>
                            <thead>
                              <tr>
                                <th className="text-nowrap">#</th>
                                <th className='text-nowrap'>Platform</th>
                                <th className='text-nowrap'>Wallet Address</th>
                                <th className='text-nowrap'>Public Key</th>
                                <th className={`text-nowrap ${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>Actions</th>

                              </tr>
                            </thead>
                            <tbody>
                              {wallets.map((item, index) => {
                                return (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td><b>{item.platformName}</b></td>
                                    <td style={{ maxWidth: "300px" }}>
                                      <p className='word-break-break-word max-line-3 m-0' title={item.address}>{item.address}</p>
                                    </td>
                                    <td style={{ maxWidth: "300px" }}>
                                      <p className='word-break-break-word m-0' title={item.publicKey}>{item.publicKey}</p>
                                    </td>
                                    <td className={`${windowSize?.width > 991 ? "sticky-actions-column" : ""}`}>
                                      <div className='d-flex gap-2'>
                                        <OverlayTriggerComponent text="View Info">
                                          <Link
                                            to={"#"}
                                            className='shadow-sm text-nowrap btn btn-primary'
                                            onClick={() => getWalletBalance(item.id)}
                                          >
                                            <i className="bx bx-show table-icon" />
                                          </Link>
                                        </OverlayTriggerComponent>
                                        <OverlayTriggerComponent text="Copy Wallet Address">
                                          <Link
                                            to={"#"}
                                            className={` shadow-sm text-nowrap btn btn-success`}
                                            onClick={() => copyLink(item.address)}
                                          >
                                            <i className="bx bx-copy table-icon" />
                                          </Link>
                                        </OverlayTriggerComponent>
                                      </div>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        ) : (
                          <div>
                            <NoData />
                            <p className='text-center mb-4'><b>Current organization does not have any wallets yet</b></p>
                          </div>
                        )
                      }
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>

      <Modal
        show={walletData ? true : false}
        onHide={onClose}
        scrollable={true}
        className='alert-confirm-modal'
        size="lg"
      >
        <Modal.Header className='' closeButton>
          <Modal.Title className="d-flex align-items-center gap-2">
            <i className="bx bx-wallet font-size-20"></i>
            Wallet Balance Information
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {walletData && (
            <>
              {/* Wallet Address */}
              <div className="mb-4">
                <label className="form-label fw-semibold text-muted mb-2">Wallet Address</label>
                <div className="d-flex align-items-center gap-2 p-3 bg-light rounded">
                  <i className="bx bx-wallet font-size-18 text-primary"></i>
                  <code className="flex-grow-1 mb-0 word-break-break-word">{walletData.address}</code>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => copyLink(walletData.address)}
                    title="Copy Address"
                  >
                    <i className="bx bx-copy"></i>
                  </button>
                </div>
              </div>

              {/* Chains */}
              {walletData.chains && walletData.chains.length > 0 ? (
                <div>
                  <label className="form-label fw-semibold text-muted mb-3">Chains & Balances</label>
                  {walletData.chains.map((chain, chainIndex) => (
                    <Card key={chainIndex} className="mb-3 shadow-sm">
                      <CardBody>
                        {/* Chain Header */}
                        <div className="d-flex align-items-center justify-content-between mb-3 pb-2 border-bottom">
                          <div className="d-flex align-items-center gap-2">
                            {chain.chainLogo && (
                              <img
                                src={chain.chainLogo}
                                alt={chain.chainName}
                                style={{ width: '32px', height: '32px', borderRadius: '50%' }}
                                onError={(e) => { e.target.style.display = 'none' }}
                              />
                            )}
                            <div>
                              <h6 className="mb-0 fw-semibold">{chain.chainName}</h6>
                              <small className="text-muted">{chain.chainSlug}</small>
                            </div>
                          </div>
                          <div className="text-end">
                            <div className="fw-bold text-primary font-size-16">
                              {chain.chainBalance?.toLocaleString(undefined, { minimumFractionDigits: 6, maximumFractionDigits: 6 }) || '0.000000'} {chain.currencySlug}
                            </div>
                            <small className="text-muted">Chain Balance</small>
                          </div>
                        </div>

                        {/* Contracts */}
                        {chain.contracts && chain.contracts.length > 0 ? (
                          <div>
                            <label className="form-label fw-semibold text-muted mb-2">Contracts</label>
                            <div className="table-responsive">
                              <Table bordered hover size="sm" className="mb-0">
                                <thead className="table-light">
                                  <tr>
                                    <th style={{ width: '40px' }}>Logo</th>
                                    <th>Token</th>
                                    <th>Contract Address</th>
                                    <th className="text-end">Balance</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {chain.contracts.map((contract, contractIndex) => (
                                    <tr key={contractIndex}>
                                      <td className="text-center">
                                        {contract.logo && (
                                          <img
                                            src={contract.logo}
                                            alt={contract.name}
                                            style={{ width: '24px', height: '24px', borderRadius: '50%' }}
                                            onError={(e) => { e.target.style.display = 'none' }}
                                          />
                                        )}
                                      </td>
                                      <td>
                                        <div>
                                          <strong>{contract.name}</strong>
                                          <br />
                                          <small className="text-muted">{contract.slug}</small>
                                        </div>
                                      </td>
                                      <td>
                                        <code className="small word-break-break-word" style={{ fontSize: '11px' }}>
                                          {contract.contractAddress}
                                        </code>
                                        <button
                                          className="btn btn-sm btn-link p-0 ms-2"
                                          onClick={() => copyLink(contract.contractAddress)}
                                          title="Copy Address"
                                        >
                                          <i className="bx bx-copy font-size-14"></i>
                                        </button>
                                      </td>
                                      <td className="text-end">
                                        <strong className="text-success">
                                          {contract.contractBalance?.toLocaleString(undefined, { minimumFractionDigits: 6, maximumFractionDigits: 6 }) || '0.000000'}
                                        </strong>
                                        <br />
                                        <small className="text-muted">{contract.slug}</small>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          </div>
                        ) : (
                          <div className="text-center py-3 text-muted">
                            <i className="bx bx-info-circle font-size-18 mb-2 d-block"></i>
                            <small>No contracts found for this chain</small>
                          </div>
                        )}
                      </CardBody>
                    </Card>
                  ))}
                </div>
              ) : (
                <div className="text-center py-4 text-muted">
                  <i className="bx bx-info-circle font-size-24 mb-2 d-block"></i>
                  <p className="mb-0">No chain data available</p>
                </div>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer className="d-flex justify-content-end">
          {/* <button className="btn btn-secondary" onClick={onClose}>
            
          </button> */}

          <Button type="button" className="shadow-sm" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default OrganizationWallets